import React, { useState, useEffect } from "react";
import Select from "react-select";
import VendorServices from "services/VendorAlotServices";

const SelectReferenceNo = ({
  register,
  handleReferenceNoChange,
  id,
  name,
  vendor_id,
  vendor_name,
  label,
  selectedReferenceNoId,
  package_type
}) => {
  const [referenceNos, setReferenceNo] = useState([]);

  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      border: "1px",
      boxShadow: "none",
      backgroundColor: "RRGGBB",
    }),
    option: (provided, state) => ({
      ...provided,
      background: state.isSelected
        ? "#0e9f6e"
        : state.isFocused
        ? "rgba(0, 0, 0, 0.15)"
        : "white",
      color: state.isSelected ? "white" : state.onClick ? "green" : "black",
      "&:hover": {
        background: "rgba(0, 0, 0, 0.15)",
        color: "black",
      },
    }),
    menu: (provided) => ({
      ...provided,
      margin: "10px 0 -10px 0",
    }),
    indicatorSeparator: () => ({
      display: "none", // Removes the separator line
    }),
  };

  useEffect(() => {
    async function fetchReferenceNo() {
      try {
       // console.log("pm",package_type)
        const response = await VendorServices.getVendorbyClientid(id,{service_type:package_type});
        const transformedData = Array.isArray(response.data)
          ? response.data.map((item) => ({
              value: item.vendor_id,
              label: item.vendor_name,
            }))
          : [];

        setReferenceNo(transformedData);
      } catch (error) {
       // console.error("Error fetching vendor data:", error);
      }
    }

    if (id) fetchReferenceNo();
  }, [id]);

  const handleReferenceNoSelect = (selected) => {
    handleReferenceNoChange(selected?.value);
  };

  return (
    <Select
      className="block w-full focus:outline-none dark:text-gray-300 leading-5 rounded-md focus:border-gray-200 border-gray-200 dark:border-gray-600 focus:ring focus:ring-green-300 dark:focus:border-gray-500 dark:focus:ring-gray-300 border h-10 text-sm bg-white-100 dark:bg-white border-transparent focus:bg-white"
      {...register(`${name}`, {
        required: !selectedReferenceNoId ? `${label} is required!` : false,
      })}
      name={name}
      styles={customSelectStyles}
      options={referenceNos}
      onChange={handleReferenceNoSelect}
      value={referenceNos.find((option) => option.value === vendor_id)}
      placeholder={`Select ${label}`}
      noOptionsMessage={() => "No vendors found in the city"} // Custom message for no options
    />
  );
};

export default SelectReferenceNo;
